import React, { use } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const NewLogin = ({ errorMessage }) => {
    const { logout, loginWithRedirect, isAuthenticated } = useAuth0();

    return <div style={{ textAlign: "center" }}>
        <img src={require('../img/resideo-black-2.png')} width="250" height="100" alt="LifeWhere" style={{maxHeight: 100 + "px", height: "auto"}} className="fusion-standard-logo fusion-logo-2x" />
        <h2>Pro-IQ&reg; LifeWhere</h2>

        {errorMessage && <p style={{ color: "red", margin: "10px 0" }}>{errorMessage}</p>}

        <div className="Login" style={{ textAlign: "center" }}>
            <button onClick={()=>{
                if(isAuthenticated) {
                    logout();
                    loginWithRedirect();
                } else {
                    loginWithRedirect();
                }
            }} className="btn-wide primary-btn btn-medium">Login</button>
        </div>
    </div>
}
export default NewLogin;